// extracted by mini-css-extract-plugin
export default {"display-ans":"DisplayAns_display-ans__Yeewp","ques-action-user":"DisplayAns_ques-action-user__dfvd2","userLink":"DisplayAns_userLink__zOMA4","userAns":"DisplayAns_userAns__CAfkp"};